import { ORDERS_HISTORY_PAGE as dict } from '@/resources/dict'

export enum Ratings {
  NONE = '0',
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
}

export const ratingsLabel = {
  [Ratings.NONE]: dict.ratings.zero,
  [Ratings.ONE]: dict.ratings.one,
  [Ratings.TWO]: dict.ratings.two,
  [Ratings.THREE]: dict.ratings.three,
  [Ratings.FOUR]: dict.ratings.four,
  [Ratings.FIVE]: dict.ratings.five,
}
